import { render, staticRenderFns } from "./AffiliateAlertsPopup.vue?vue&type=template&id=61741952&scoped=true&"
import script from "./AffiliateAlertsPopup.vue?vue&type=script&lang=js&"
export * from "./AffiliateAlertsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61741952",
  null
  
)

export default component.exports